import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const ROLES: ComboBoxItem<string>[] = [
  { id: 0, label: "Developer", value: "Developer" },
  { id: 1, label: "Researcher", value: "Researcher" },
  { id: 2, label: "Consultant", value: "Consultant" },
  { id: 3, label: "Product Manager", value: "Product Manager" },
  { id: 4, label: "Team Manager", value: "Team Manager" },
  { id: 5, label: "Founder / Co-Founder", value: "Founder / Co-Founder" },
  { id: 6, label: "CEO", value: "CEO" },
  { id: 7, label: "CTO", value: "CTO" },
  { id: 8, label: "Others", value: "Others" },
];

export default ROLES;
